export const GRID = 'grid';
export const MAP = 'map';
export const LIST = 'list';
